import Node from 'ln/node/Node';
import Lang from 'ln/lang/Lang';
import CourseElement from './CourseElement';
import CustomBaseModel from '../models/CustomBase';
import Course from './Course';


class CustomBase extends CourseElement {

	constructor( public model:CustomBaseModel, private courseView: Course ) {
		super( model, courseView );

	}
	
	public init(){
		super.init();

		this.node.js( 'title' ).change.add( this.onTitleChange, this );
		this.node.js( 'module' ).change.add( this.onModuleChange, this );
		this.node.js( 'time' ).change.add( this.onTimeChange, this );
		const done = this.node.js( 'done' );
		done.click.add( this.onDoneClicked, this );
		done.native.classList.toggle( '-checked', this.model.done );

		this.renderDisplayTime();

		this.blankLinks();
	}

		
	private onTimeChange( n:Node ) {
		this.model.time = parseInt( n.value );
		this.model.save();
		
		// update round time button
		this.node.js( 'timeline-button' ).html = n.value + '\'';

		// update the course header
		this.courseView.rerenderComputedProperties();
		
		this.model.course.rerenderDisplayTime.dispatch();
	}

	private onTitleChange( n:Node ){
		this.model.title = n.value;
		this.model.save();
	}

	private onDoneClicked( n:Node ){
		this.model.done = !this.model.done;
		this.model.save();
		n.native.classList.toggle( '-checked' );
	}

	private onModuleChange( n:Node ){
		this.model.module = n.value;
		this.model.save();
	}

	protected renderDisplayTime() {
		this.node.js('display-time').html = this.model.displayTime + ' ' + Lang.translate( 'processplan.time' );
	}
}

export default CustomBase;